module.exports = __webpack_public_path__ + "img/2152e11840923acfbc180afec1bf45f8.png";